import { render, staticRenderFns } from "./currentDiscuss.vue?vue&type=template&id=44eabb68&scoped=true"
import script from "./currentDiscuss.vue?vue&type=script&lang=js"
export * from "./currentDiscuss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44eabb68",
  null
  
)

export default component.exports